<template>
  <div>
    <!-- 出発時間 今すぐのみ(2022/06/20) -->
    <demandSelectForm
      :vmodel="pickuptime"
      label="乗車日時"
      :options="[{ value: 'current', string: '今すぐ' }]"
      :disabled="true"
    />

    <!-- 価格区分ごとに何人乗るか選択 -->
    <selectDivisionSeatCountForm
      v-for="(division, index) in divisionObject"
      :key="index"
      :division="division"
      :changed="changed"
    />

    <div class="yellow_div">※車両の構造上、車いすの方はご乗車になれません</div>

    <!-- 選択した価格区分人数に対する注釈 -->
    <caution v-if="errorString" :string="errorString" :colored="true" />
  </div>
</template>

<script>
import { useVModel } from "vue-composable";
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
export default {
  name: "TheDemandSelectSeatCountAndPickupTime",
  props: {
    seatCount: {
      type: Object,
      require: true,
    },
    pickuptime: {
      type: String,
      require: true,
    },
    isValidSeatCount: {
      typr: Boolean,
      require: true,
    },
  },
  setup(props) {
    const store = useStore();
    const selectedService = computed(
      () => store.getters["demand/selectedService"]
    );

    // 価格区分ごとに何枚選択されたかを保持
    const seatCount = useVModel(props, "seatCount");

    // 出発時間 今すぐのみ(2022/06/20)
    const pickuptime = useVModel(props, "pickuptime");

    // 入力された人数が有効かのフラグ
    const isValidSeatCount = useVModel(props, "isValidSeatCount");

    // 価格区分が増えるかもしれないので汎用的にObject
    const divisionObject = computed({
      get() {
        return store.getters["demand/divisionObject"];
      },
      set(value) {
        store.commit("demand/setDivisionObject", value);
      },
    });

    const errorString = ref(null);

    onMounted(async () => {
      assignedValue();
    });

    // 価格区分ごとに何枚選択されたかのseatCountに代入
    const assignedValue = async () => {
      seatCount.value["adult"] = divisionObject.value.adult.count;
      seatCount.value["child"] = divisionObject.value.child.count;
      seatCount.value["infant"] = divisionObject.value.infant.count;
    };

    // 人数selectの値が変わるたびに発火
    const changed = async () => {
      assignedValue();
      // 親コンポーネントのisValidSeatCountをコントロール
      isValidSeatCount.value = checkSeatCount();
    };

    // sValidSeatCountのコントロールバリデーション
    const checkSeatCount = () => {
      if (
        divisionObject.value.adult.count == 0 &&
        divisionObject.value.child.count == 0 &&
        divisionObject.value.infant.count == 0
      ) {
        // 全division == 0
        errorString.value = "※ 1名以上選択してください";
        return false;
      } else if (
        divisionObject.value.infant.count > 0 &&
        divisionObject.value.adult.count == 0
      ) {
        // 幼児が1以上なら、おとな1以上が条件
        errorString.value =
          "※ 幼児(6歳未満)を1名以上選択した場合、おとなを1名以上選択してください";
        return false;
      } else if (overCapacity.value) {
        // デマンドカーのキャパ超え
        errorString.value =
          "※ 利用できる人数は合計" +
          selectedService.value.capacity +
          "名までです";
        return false;
      } else {
        errorString.value = null;
        return true;
      }
    };

    // サービス概要に指定されたキャパをオーバーしてるか
    const overCapacity = computed(() => {
      return (
        divisionObject.value.infant.count +
          divisionObject.value.adult.count +
          divisionObject.value.child.count >
        selectedService.value.capacity
      );
    });

    return {
      divisionObject,
      pickuptime,
      overCapacity,
      selectedService,
      changed,
      errorString,
    };
  },
};
</script>

<style lang="scss" scoped>
.yellow_div {
  margin: auto;
  text-align: center;
  padding: 10px 0 15px;
  font-weight: bold;
  font-size: 0.8rem;
}
</style>
